import React, { useState, useEffect, useCallback } from "react";
import { userService } from "../../_services";
import Add_referal_url_pop from './Add_referal_url_pop';
import Delete_referal_url_pop from './Delete_referral_url_popup';
import copy from "copy-to-clipboard";
import Pagination from '@/components/ui/pagination';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Loader2, Copy, Trash2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

function Affiliate_refferal_url_list({ refreshKey }) {
    const [urlList, setUrlList] = useState([]);
    const [openEditPopup, setOpenEditPopup] = useState(false);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [urlId, setUrlId] = useState('');
    const [urlText, setUrlText] = useState('');
    const [copiedId, setCopiedId] = useState(null);
    const [showLogic, setShowLogic] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pageOfItems, setPageOfItems] = useState([]);

    const fetchURLList = useCallback(() => {
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const userName = Usermeta_Data.split(':')[1];
            const userId = Usermeta_Data.split(':')[0];
            setLoading(true);
            userService.GetReferralURLList(userName, userId)
                .then(apidata => {
                    if (apidata && apidata.length > 0) {
                        setUrlList(apidata);
                        setShowLogic(false);
                    } else {
                        setUrlList([]);
                        setShowLogic(true);
                    }
                    setLoading(false);
                })
                .catch(() => {
                    setShowLogic(true);
                    setLoading(false);
                });
        } catch (error) {
            setShowLogic(true);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchURLList();
    }, [fetchURLList]);

    useEffect(() => {
        if (refreshKey !== undefined) fetchURLList();
    }, [refreshKey, fetchURLList]);

    const toggleEditPopup = (e) => {
        e.stopPropagation();
        if (!openEditPopup) {
            setUrlId(e.target.getAttribute('data-id'));
            setUrlText(e.target.getAttribute('data-text'));
            setOpenEditPopup(true);
        } else {
            fetchURLList();
            setOpenEditPopup(false);
        }
    };

    const toggleDeletePopup = () => {
        fetchURLList();
        setOpenDeletePopup(false);
    };

    const Copytext = (e, itemId) => {
        copy(e.currentTarget.getAttribute('data-text'));
        setCopiedId(itemId);
        setTimeout(() => setCopiedId(null), 2000);
    };

    const baseURL = window.location.protocol + '//' + window.location.host + '/ref';
    const dataToDisplay = pageOfItems;

    return (
        <div>
            <div className="max-h-[152px] overflow-y-auto">
                <Table>
                    <TableHeader className="sticky top-0 z-10 bg-card">
                        <TableRow>
                            <TableHead>Referral URL</TableHead>
                            <TableHead>Number of Signups</TableHead>
                            <TableHead>Action</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {loading ? (
                            <TableRow>
                                <TableCell colSpan={3} className="text-center py-6">
                                    <Loader2 className="h-8 w-8 animate-spin text-accent mx-auto" />
                                </TableCell>
                            </TableRow>
                        ) : !showLogic && dataToDisplay.length > 0 ? (
                            dataToDisplay.map((uitem) => {
                                const fullUrl = baseURL + '/' + uitem.endPointText;
                                return (
                                    <TableRow key={"URLKey" + uitem.id}>
                                        <TableCell className="break-all">{fullUrl}</TableCell>
                                        <TableCell>{uitem.signUpCount}</TableCell>
                                        <TableCell>
                                            <div className="flex items-center gap-3">
                                                <TooltipProvider>
                                                    <Tooltip open={copiedId === uitem.id ? true : undefined}>
                                                        <TooltipTrigger asChild>
                                                            <Button
                                                                variant="ghost"
                                                                size="icon"
                                                                type="button"
                                                                data-text={fullUrl}
                                                                onClick={(e) => Copytext(e, uitem.id)}
                                                                aria-label="Copy referral URL"
                                                            >
                                                                <Copy data-text={fullUrl} className="w-4 h-4" />
                                                            </Button>
                                                        </TooltipTrigger>
                                                        <TooltipContent>
                                                            <p>{copiedId === uitem.id ? 'Copied' : 'Copy'}</p>
                                                        </TooltipContent>
                                                    </Tooltip>
                                                </TooltipProvider>
                                                <Button
                                                    variant="ghost"
                                                    size="icon"
                                                    type="button"
                                                    onClick={() => {
                                                        setUrlId(String(uitem.id));
                                                        setUrlText(uitem.endPointText);
                                                        setOpenDeletePopup(true);
                                                    }}
                                                    aria-label="Delete referral URL"
                                                >
                                                    <Trash2 className="w-4 h-4" />
                                                </Button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : !loading ? (
                            <TableRow>
                                <TableCell colSpan={3} className="text-center py-6 text-accent">
                                    No URLs found
                                </TableCell>
                            </TableRow>
                        ) : null}
                    </TableBody>
                </Table>
            </div>

            {!loading && !showLogic && urlList.length > 0 && (
                <div className="p-4 border-t">
                    <Pagination items={urlList} onChangePage={setPageOfItems} />
                </div>
            )}

            {openEditPopup && (
                <Add_referal_url_pop
                    toggle_Edit_popup={toggleEditPopup}
                    URL_Id={urlId}
                    URL_Text={urlText}
                    PopupTitle='Edit Affiliate Referral URL'
                    ButtonText='Update'
                />
            )}
            {openDeletePopup && (
                <Delete_referal_url_pop
                    toggle_Delete_popup={toggleDeletePopup}
                    URL_Id={urlId}
                    URL_Text={urlText}
                    PopupTitle='Delete Affiliate Referral URL'
                    PopupMessage='Are you sure want to delete this URL?'
                    ButtonText='Delete'
                />
            )}
        </div>
    );
}

export default Affiliate_refferal_url_list;

